module.exports = __webpack_public_path__ + "img/visa.aba48a7f.png";